import { render } from "./MainNav.vue?vue&type=template&id=03e14507&scoped=true"
const script = {}

import "./MainNav.vue?vue&type=style&index=0&id=03e14507&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\zacha\\repos\\jhhe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e14507"]])

export default __exports__